module.exports = __webpack_public_path__ + "img/words8.40f28cdf.png";